import type { TipoCliente } from '@acme/core'
import ApiService from '../api.service'

export type TipoDocumentoLegal = 'TERMOS' | 'POLITICA'
export type StatusAceite = 'ACEITO' | 'PENDENTE' | 'DISCORDOU'

export interface VersaoDocumentoLegal {
    id: number
    tipo: TipoDocumentoLegal
    numero: number | null
    conteudoMarkdown: string
    hashConteudo: string | null
    publicadoEm: string | null
    createdAt: string
    updatedAt: string
}

export type VersaoResumo = Pick<
    VersaoDocumentoLegal,
    'id' | 'numero' | 'publicadoEm' | 'conteudoMarkdown'
>

export interface PendenciaDocumento {
    tipo: TipoDocumentoLegal
    status: StatusAceite
    vigente: VersaoResumo
}

export interface Pendencias {
    isDono: boolean
    isCpfObrigatorio?: boolean
    /** CPF do responsável da empresa mais antiga que tem um */
    cpfResponsavel?: string | null
    documentos: PendenciaDocumento[]
}

export interface AceiteCliente {
    id: number
    nomeFantasia: string
    cnpj: string | null
    tipo: TipoCliente
    termos: { status: StatusAceite; respondidoEm: string | null }
    politica: { status: StatusAceite; respondidoEm: string | null }
}

export const TITULOS_DOCUMENTO: Record<TipoDocumentoLegal, string> = {
    TERMOS: 'Termos de uso',
    POLITICA: 'Política de privacidade',
}

interface FiltroTipo {
    tipo: TipoDocumentoLegal
}

export interface CriarRascunho extends FiltroTipo {
    conteudoMarkdown: string
}

export interface ResponderDocumento {
    versaoId: number
    resposta: 'CONCORDO' | 'DISCORDO'
    cpf?: string
}

/** Versões dos documentos: o rascunho primeiro, depois as publicadas da mais nova à mais antiga. */
export const termosPoliticas = new ApiService<
    CriarRascunho,
    VersaoDocumentoLegal,
    FiltroTipo
>('termos-politicas')
/** Rota pública: o queryClient desliga as queries sem sessão, daí `enabled: true` no uso. */
export const documentoVigente = new ApiService<never, VersaoResumo, FiltroTipo>(
    'termos-politicas/vigente',
)
export const aceitesTermos = new ApiService<
    FiltroTipo & { clienteId: number },
    AceiteCliente
>('termos-politicas-aceites')
export const respostasTermos = new ApiService<ResponderDocumento | FiltroTipo>(
    'termos-politicas-respostas',
)
export const pendenciasTermos = new ApiService<never, Pendencias>(
    'termos-politicas-respostas/pendencias',
)
